module.exports = __webpack_public_path__ + "static/banner-d1f0760641c1e6ac1e1a02e3ab05b735.png";